import React, {Component} from "react";
import {withNamespaces} from "react-i18next";
import {connect} from "react-redux";
import {DataService} from "../../../PilotPttRzeszow/services/data.service";
import {Button, ButtonGroup, Spinner} from "react-bootstrap";
import StompClient from "react-stomp-client";
import {pathHelper} from "../../../../helpers/path-helper";

 class WidgetCustomButtons extends Component {

     state = {
         data: null,
         buttonData: [],
         loading: false
     }
     componentDidMount() {
         DataService.getDataJsonFileByName('pilot')
             .then(
                 (res) => {
                     this.setState({
                         data: res,
                         buttonData: res.buttons,
                         loading: true
                     })
                 }
             )
     }
     handleMessage = (msg) => {
         const { buttonData } = this.state;
         const payload = JSON.parse(msg.body);
         const result = buttonData;
         if(result) {
             result.forEach((item,idx) => {
                 const findElement = payload.find((x) => x.name === item.name);
                 if(findElement) {
                     item.isActive = findElement.isActive
                 }
             })

             this.setState({
                 ...this.state,
                 buttonData: result
             })
        }
    }

    render() {
         const { loading, buttonData } = this.state;
         const { callbackAction, t } = this.props;
         return (
            <div className="card ">
                <div className="card-header">
                    <div className="card-title d-flex w-100">
                        <b className="align-self-center">{ t('custom-buttons') }</b>
                        <div className="ml-auto d-flex">
                        </div>
                    </div>
                    <StompClient
                        endpoint={`ws://${pathHelper.getUrlHostname()}:15674/ws`}
                        topic={"exchange/amq.topic/nodered.button.state"}
                        onMessage={this.handleMessage}
                    >
                        <div className="card-body">
                            { loading  ? (
                                buttonData?.map((item,idx) => {
                                    console.log(item);
                                    return (
                                        <Button
                                            key={idx}
                                            className={`m-2 ${item.isActive ? "active": ""}`}
                                            size={"lg"}
                                            variant={"outline-primary"}
                                            onClick={(e) => {
                                                const url = item.url.replaceAll("%hostname%", pathHelper.getUrlHostname());
                                                callbackAction(url, item.authorize)
                                            }}>
                                            {t(item.label)}
                                        </Button>
                                    )
                                })

                            )  : (<Spinner animation={"border"} /> ) }
                        </div>
                    </StompClient>
                </div>
            </div>
        )
    }
}
const mapStateToProps = state => {
    const {user} = state.authenticationReducer;
    return {
        user
    }
};
export default withNamespaces()(connect(mapStateToProps)(WidgetCustomButtons));
